import { Injectable } from '@angular/core';
import { AddressModel } from '../models/address.model';
import { AppService } from '../app.service';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class BuscaCepService extends AppService<AddressModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async getByCep(cep: string) {
    const result = await this.getAsync(`BuscaCep/cep/${cep}`);
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/busca-cep.service.ts